var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4757 9.00002L24.1424 4.33335M26.8091 1.66669L24.1424 4.33335L26.8091 1.66669ZM13.9957 14.48C14.6842 15.1593 15.2315 15.9681 15.6061 16.8597C15.9807 17.7514 16.1752 18.7084 16.1785 19.6755C16.1817 20.6427 15.9936 21.6009 15.625 22.4951C15.2563 23.3892 14.7145 24.2017 14.0306 24.8855C13.3467 25.5694 12.5343 26.1113 11.6402 26.4799C10.746 26.8485 9.78775 27.0366 8.82059 27.0334C7.85344 27.0301 6.89647 26.8356 6.0048 26.461C5.11313 26.0864 4.30437 25.5391 3.62508 24.8507C2.28926 23.4676 1.5501 21.6152 1.56681 19.6924C1.58351 17.7696 2.35475 15.9303 3.71441 14.5707C5.07407 13.211 6.91336 12.4398 8.83614 12.4231C10.7589 12.4064 12.6113 13.1455 13.9944 14.4814L13.9957 14.48ZM13.9957 14.48L19.4757 9.00002L13.9957 14.48ZM19.4757 9.00002L23.4757 13L28.1424 8.33335L24.1424 4.33335L19.4757 9.00002Z",
    stroke: "#F04E6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyLogo);
export default __webpack_public_path__ + "static/media/key-logo.4a6baed7fd019a93d37a2b0858966d58.svg";
export { ForwardRef as ReactComponent };